module.exports = __webpack_public_path__ + "static/media/GPTW_Certified_RGB_HIGH_RES_PNG.8fe240c3.png";